import { render, staticRenderFns } from "./TradeStateRelatedSettingTable.vue?vue&type=template&id=1d7f4bcf&"
import script from "./TradeStateRelatedSettingTable.vue?vue&type=script&lang=js&"
export * from "./TradeStateRelatedSettingTable.vue?vue&type=script&lang=js&"
import style0 from "./TradeStateRelatedSettingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports